import RipplePulse from '../common/loader-components/RipplePulse'
import { useRouter } from 'next/router'
import { useOrganisationContext } from 'src/lib/contexts/OrganisationContext'
import { useLocale } from 'src/lib/hooks/useLocal'
import { MoneyWavy } from '@phosphor-icons/react'
import { Button, Icon } from '@shopflo/ui'
import { classNames } from 'src/lib/utils/helpers'
import { motion } from 'motion/react'
import useNavigation from 'src/lib/hooks/useNavigation'
import { useUser } from 'src/lib/contexts/UserContext'
import { permissionType } from 'src/lib/utils/constants'

const BillingWidget = () => {
  const router = useRouter()
  const {
    actions: { resetAndRedirect }
  } = useNavigation()
  const {
    getters: { status }
  } = useOrganisationContext()
  const { t } = useLocale()

  const { canAccess, isUserConfigured } = useUser()

  const isBillingPage = router.pathname === '/billing'

  return (
    <motion.div transition={{ duration: 0.2 }} id='tab-invoices'>
      <Button
        variant='outline'
        size='sm'
        onClick={() => resetAndRedirect('/billing')}
        className={classNames('bg-gray-100 shadow-none ', isBillingPage ? 'bg-white border-none' : '')}
        disabled={!canAccess(permissionType.TAB_INVOICES, 0) || !isUserConfigured}
      >
        <div className='flex items-center gap-x-1'>
          {['SECOND-REMAINDER', 'FIRST-REMAINDER', 'overdue'].includes(status) ? (
            <RipplePulse color='bg-red-dark' />
          ) : (
            <></>
          )}
          <Icon IconComponent={MoneyWavy} size='sm' className='text-zinc-600' />
          <span className='text-zinc-600 font-semibold text-sm leading-[18px] px-1'>{t('billing.title')}</span>
        </div>
      </Button>
    </motion.div>
  )
}

export default BillingWidget
